import type { FoundationProjectionReadV1 } from "@impetusos/contracts"

export const stateLabel = (projection: FoundationProjectionReadV1 | null): string => {
  if (projection === null || !projection.found) return "Not initialized"
  return projection.record.state[0]?.toUpperCase() + projection.record.state.slice(1)
}

export const stateVersion = (projection: FoundationProjectionReadV1 | null): number =>
  projection?.found ? projection.record.version : 0

export const stateTone = (
  projection: FoundationProjectionReadV1 | null
): "quiet" | "positive" | "attention" => {
  if (projection === null || !projection.found) return "quiet"
  return projection.record.state === "active" ? "positive" : "attention"
}
